export default {
    info:   	'<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12" y2="8"></line></g>',
    check:  	'<polyline points="20 6 9 17 4 12"></polyline></g>',
    bell:		'<path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></g>',
    not:    	'<circle cx="12" cy="12" r="10"></circle><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line></g>',
    up:     	'<polyline points="18 15 12 9 6 15"></polyline></g>',
};